import {
  GET_AGENCY_REWARD_DETAILS_START,
  GET_AGENCY_REWARD_DETAILS_COMPLETE,
  GET_AGENCY_REWARD_DETAILS_ERROR,
  UPDATE_AGENCY_REWARD_DETAILS_START,
  UPDATE_AGENCY_REWARD_DETAILS_COMPLETE,
  UPDATE_AGENCY_REWARD_DETAILS_ERROR,
  GET_ESTIMATED_MONTHLY_COST_START,
  GET_ESTIMATED_MONTHLY_COST_COMPLETE,
  GET_ESTIMATED_MONTHLY_COST_ERROR,
} from './actions';
import { LOGOUT } from '../login/actions';

let initialState = {
  agencyRewardDetailsError: undefined,
  agencyRewardData: undefined,
  isAgencyRewardDetailsStarted: false,
  updateAgencyRewardDetailsError: undefined,
  isUpdateAgencyRewardDetailsStarted: false,
  estimatedMonthlyCost: undefined,
  estimatedMonthlyCostError: undefined,
  isEstimatedMonthlyCostStarted: false,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_AGENCY_REWARD_DETAILS_START:
      return {
        ...state,
        isAgencyRewardDetailsStarted: true,
        agencyRewardDetailsError: undefined,
        agencyRewardData: undefined,
      };
    case GET_AGENCY_REWARD_DETAILS_COMPLETE:
      return {
        ...state,
        agencyRewardData: payload.data,
        isAgencyRewardDetailsStarted: false,
        agencyRewardDetailsError: undefined,
      };
    case GET_AGENCY_REWARD_DETAILS_ERROR:
      return {
        ...state,
        agencyRewardDetailsError: payload.error,
        isAgencyRewardDetailsStarted: false,
        agencyRewardData: undefined,
      };
    case UPDATE_AGENCY_REWARD_DETAILS_START:
      return {
        ...state,
        isUpdateAgencyRewardDetailsStarted: true,
        updateAgencyRewardDetailsError: undefined,
      };
    case UPDATE_AGENCY_REWARD_DETAILS_COMPLETE:
      return {
        ...state,
        isUpdateAgencyRewardDetailsStarted: false,
        updateAgencyRewardDetailsError: undefined,
      };
    case UPDATE_AGENCY_REWARD_DETAILS_ERROR:
      return {
        ...state,
        updateAgencyRewardDetailsError: payload.error,
        isUpdateAgencyRewardDetailsStarted: false,
      };

    case GET_ESTIMATED_MONTHLY_COST_START:
      return {
        ...state,
        isGetEstimatedMonthlyCostStarted: true,
        estimatedMonthlyCostError: undefined,
        estimatedMonthlyCost: undefined,
      };
    case GET_ESTIMATED_MONTHLY_COST_COMPLETE:
      return {
        ...state,
        isGetEstimatedMonthlyCostStarted: false,
        estimatedMonthlyCostError: undefined,
        estimatedMonthlyCost: payload.data,
      };
    case GET_ESTIMATED_MONTHLY_COST_ERROR:
      return {
        ...state,
        estimatedMonthlyCostError: payload.error,
        isGetEstimatedMonthlyCostStarted: false,
        estimatedMonthlyCost: undefined,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
